import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

export default function Pending() {
  const { user } = useAuth();
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="max-w-xl w-full border border-white/15 bg-[#181825] p-8 corner-tick">
        <div className="label-mono text-[#d4b876]">STATUS · {user?.status?.toUpperCase() || "PENDING"}</div>
        <h1 className="font-display text-3xl mt-3">Awaiting clerk verification</h1>
        <p className="text-white/70 mt-4 leading-relaxed">
          {user?.status === "rejected"
            ? "Your application has been declined by the Band Registry Clerk. Please contact the registry office to resolve any discrepancies."
            : "Your application is queued for review by the Band Registry Clerk. Once your information is verified against the legacy registry file, your account will be approved and full portal access will unlock."}
        </p>
        <div className="mt-6 border border-white/10 p-4 font-mono text-xs text-white/60">
          <div className="label-mono mb-2">Submitted</div>
          <div>{user?.first_name} {user?.last_name}</div>
          <div>{user?.email}</div>
          <div>Registry #: {user?.band_registry_number}</div>
        </div>
        <div className="mt-6 flex gap-3">
          <Link to="/" className="btn-cta" data-testid="pending-home-btn">Return home</Link>
          <Link to="/contact" className="btn-cta gold" data-testid="pending-contact-btn">Contact registry</Link>
        </div>
      </div>
    </div>
  );
}
